<template>
  <v-menu location="bottom start" @update:model-value="$emit('toggle', $event)">
    <template #activator="{props}">
      <v-btn v-bind="props" variant="text" class="shell-menu shell-plain-case">
        <!-- Sem escolha, a palavra É o conteúdo do controle e ocupa uma linha só;
             escolhida uma, ela sobe e vira o rótulo do que está escolhido. Empilhar as
             duas antes da escolha daria "Coleção / Coleções" — a mesma palavra duas
             vezes, e a de baixo sem informação nenhuma. -->
        <span class="shell-stack">
          <span v-if="value" class="shell-label">{{ label }}</span>
          <span class="shell-value">{{ value || label }}</span>
        </span>
        <v-icon end size="x-small">mdi-chevron-down</v-icon>
      </v-btn>
    </template>
    <v-list density="compact" min-width="200">
      <v-progress-linear v-if="loading" indeterminate/>
      <slot/>
    </v-list>
  </v-menu>
</template>

<script lang="ts">
import {Component, Vue, Prop, toNative} from 'vue-facing-decorator'

/**
 * Seletor da barra: o que está escolhido, com o rótulo do que ele é, e a lista para
 * trocar.
 *
 * Existe para o ambiente e para a coleção dizerem a mesma coisa do mesmo jeito. O
 * rótulo em cima não é enfeite: "Noel" sozinho na barra não diz se é o ambiente, a
 * coleção ou o usuário — e é o mesmo idioma do caminho logo abaixo, o que faz a barra e
 * o caminho lerem como uma coisa só.
 *
 * O `toggle` sobe porque quem usa pode precisar carregar a lista na primeira abertura;
 * quem já tem os itens em mãos simplesmente ignora o evento.
 */
@Component({name: 'ontos-shell-menu', emits: ['toggle']})
class ShellMenu extends Vue {
  @Prop({type: String, required: true}) readonly label!: string
  @Prop({type: String, default: ''}) readonly value!: string
  @Prop({type: Boolean, default: false}) readonly loading!: boolean
}

export default toNative(ShellMenu)
</script>

<style scoped>
/* O padding menor à direita encosta a seta no texto, para o par "valor + seta" ler
   como um controle só. A caixa mista vem do shell-plain-case, no App.vue.

   **`flex: 0 1 auto` com `min-width: 0` é o que faz o seletor ENCOLHER.** O `v-btn` do Vuetify é
   `flex-shrink: 0` e o conteúdo dele é `flex: 1 0 auto`, então os dois seletores eram rígidos: no
   aperto, quem cedia era o único elástico da barra — o invólucro das abas de coleção, que no
   telefone É o seletor de coleção. Ele era esmagado até virar "COLEÇ" sem seta e, com nome de
   ambiente longo, desaparecia por completo; e o pior é que nada PARECIA cortado.
   Encolhendo os dois, a pressão se reparte e o nome corta com reticências, que o `shell-value`
   já sabe fazer. O piso é o rótulo ("AMBIENTE", "COLEÇÃO"), que não encolhe — e é o certo: sem
   ele, "Noel" sozinho na barra não diz se é o ambiente ou a coleção.

   No xs o recuo e a folga são menores: a folga de 8px aqui é a mesma coisa que o `ga-1` do grupo
   de ações faz, e nesta largura cada par de pixels é um caractere de nome a mais. */
.shell-menu {
  flex: 0 1 auto;
  min-width: 0;
  margin-inline-end: 0;
  padding-inline: 4px;
}

.shell-menu :deep(.v-btn__content) {
  min-width: 0;
}

/* A folga depois do seletor acompanha a do logo: quando há largura, o ambiente se
   descola das abas de coleção e a barra lê em três blocos — quem sou, onde estou,
   o que faço. Apertado, ela some, que é o certo no telefone. */
@media (min-width: 600px) {
  .shell-menu {
    margin-inline-end: 16px;
    padding-inline: 8px;
  }
}

@media (min-width: 960px) {
  .shell-menu {
    margin-inline-end: 32px;
  }
}
</style>
